import React, { useState } from 'react'

import WebApp from '@twa-dev/sdk'
import { useNavigate } from 'react-router-dom'

import { AppContext } from '@/components/base/appcontext'

import { Alert } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import { Typography } from '@/components/ui/typography'

import { RotateCcw } from 'lucide-react'

function UndefinedUser() {
    const appContext = React.useContext(AppContext)
    const navigate = useNavigate()

    const [blocked, setBlocked] = useState(false)

    return (
        <>
            <Alert variant="destructive" className="m-2 rounded-lg">
                <div className="col-span-2 flex items-center w-full gap-2">
                    <span>⚠️</span>
                    <Typography
                        variant="title-sm"
                        textAlign="center"
                        className="text-destructive flex-1"
                    >
                        {appContext.geti18n('onboarding.error.undefinedUser')}
                    </Typography>
                    <div className="flex items-center gap-2">
                        <Button
                            disabled={blocked}
                            variant="destructive"
                            onClick={() => {
                                setBlocked(true)
                                localStorage.clear()
                                navigate(0)
                            }}
                        >
                            {appContext.geti18n('onboarding.error.clearCache')}
                        </Button>
                        <Button
                            variant="ghost"
                            size="icon"
                            disabled={blocked}
                            onClick={() => {
                                setBlocked(true)
                                navigate('/?reauth=true')
                            }}
                        >
                            <RotateCcw className="h-4 w-4 text-yellow-500" />
                        </Button>
                    </div>
                </div>
            </Alert>
            {WebApp.initData && (
                <Typography variant="body-xs">{WebApp.initData}</Typography>
            )}
        </>
    )
}

export default UndefinedUser
